<template>
    <Layout>
        <section class="fieldset center">
            <div class="error-page">
                <span>
                    <font-awesome-icon icon="exclamation-triangle"/>
                </span>
                <span  v-if="!Utils.isThemeSuivideflotte()">
                  {{ $t('login.errors.persist') }}
                </span>
                <span  v-else>
                   Si l'erreur persiste, merci de contacter le support technique au numéro vert suivant : <a href="tel:0800688674">0800 688 674</a> ou par email à <a href="mailto:support@suivideflotte.net">support@suivideflotte.net</a>
                </span>
            </div>
        </section>
    </Layout>
</template>

<script>
    //import Component from 'path/to/component'

    import Layout from '@l/BaseWithToolbar'
    import {mapGetters, mapMutations, mapActions, mapState} from 'vuex'
    import Utils from "../services/utils";

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Layout
        },
        computed: {
          Utils() {
            return Utils
          }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                showLoading: 'UI/showLoading',
                viewTitle: 'UI/viewTitle',
            }),
        },
        mounted: function () {
            this.viewTitle(window.V.$i18n.t("login.errors.errorTitle"))
            this.showLoading(false);
        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Error.vue